module.exports = __webpack_public_path__ + "img/allClass.27ea8e52.png";